import {
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_BEGIN,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_SUCCESS,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_FAILURE,
  DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
export function createCollectionWithSalesforce(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/salesforce/create-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_SUCCESS,
            data: res,
          });
          Mixpanel.track('Created Collection', {
            uuid: res.data.uuid,
            colletionName: res.data.colletionName,
          });
          toast.success('Collection Created Successfully !');
          resolve(res);
        },
        (err) => {
          const errMsg = getErrorMessageFromResponse(err.response) || ` to create Collection !`;
          toast.error(`Failed: ${errMsg}`);
          Mixpanel.track('Failed to creat collection');
          dispatch({
            type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionWithSalesforceError() {
  return {
    type: DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_BEGIN:
      return {
        ...state,
        createCollectionWithSalesforcePending: true,
        createCollectionWithSalesforceError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_SUCCESS:
      return {
        ...state,
        createCollectionWithSalesforcePending: false,
        createCollectionWithSalesforceError: null,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_FAILURE:
      return {
        ...state,
        createCollectionWithSalesforcePending: false,
        createCollectionWithSalesforceError: action.data.error,
      };

    case DATA_CONNECTOR_CREATE_COLLECTION_WITH_SALESFORCE_DISMISS_ERROR:
      return {
        ...state,
        createCollectionWithSalesforceError: null,
      };

    default:
      return state;
  }
}
